import { useContext } from 'react';
import { AuthContextFirebase } from '../Authenticate/AuthenticateFirebase';
import saveTextToFile from '../../utils/saveTextToFile';
import { trackEvent } from '../../utils/tracking';

const useDownloadConfigAndroid = (): (() => void) => {
  const {
    data: { serviceToken },
  } = useContext(AuthContextFirebase);

  return () => {
    trackEvent('Setup.DownloadConfig', {
      platform: 'android',
    });

    saveTextToFile(
      'bitrise-addons-configuration.json',
      'json',
      `{
  "version": "1.0.0",
  "token": "${serviceToken}"
}
`,
    );
  };
};

export default useDownloadConfigAndroid;
